import PropTypes from 'prop-types';
import { useMemo, Fragment } from 'react';
// mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const escapeRegExp = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export default function ItemHighlight({ text, query }) {
  const parts = useMemo(() => {
    if (!query) return [text];
    const regex = new RegExp(`(${escapeRegExp(query)})`, 'ig');
    return text.split(regex);
  }, [text, query]);

  return (
    <>
      {parts.map((part, index) =>
        query && part.toLowerCase() === query.toLowerCase() ? (
          <Box
            key={index}
            component='span'
            color='primary.main'
            sx={{
              typography: 'body2',
              fontWeight: 'fontWeightSemiBold',
            }}
          >
            {part}
          </Box>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        )
      )}
    </>
  );
}

ItemHighlight.propTypes = {
  text: PropTypes.string,
  query: PropTypes.string,
};